import styled, { css } from 'styled-components';

interface ButtonProps {
  isActive?: boolean;
}

export const Container = styled.button<ButtonProps>`
  width: auto;
  height: 40px;
  color: var(--primary);
  background: transparent;
  padding: 0 20px;
  border: 0;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  outline: none;

  ${props =>
    props.isActive &&
    css`
      background: var(--primary-transparent);
    `}

  display: flex;
  justify-content: center;
  align-items: center;
`;
